'use client'

import dayjs from '@/lib/dayjs'
import { getTimeAttackCutoff } from '@/lib/time-attack-leaderboard'
import { useMemo } from 'react'
import IRacingTimeAttackStandings from './iracing-standings'
import LinkIRacingButton from './link-iracing-button'

export default function IracingLeaderboard({
  event,
  eventAttendees,
  session,
  params,
}) {
  const sessionUserId = session?.user?.id
  const userAttendee = useMemo(
    () => eventAttendees?.find((ea) => ea.user.id === sessionUserId),
    [eventAttendees, sessionUserId],
  )

  const isStarted = useMemo(
    () => dayjs(event.startDateTime).isBefore(dayjs()),
    [event.startDateTime],
  )

  return (
    <div className="flex flex-col gap-2">
      {/* iRacing link button */}
      {userAttendee && <LinkIRacingButton session={session} />}

      <h4 className="text-h-4 font-semibold">Time Attack Leaderboard</h4>
      {isStarted ? (
        <IRacingTimeAttackStandings
          cutoff={getTimeAttackCutoff(event)}
          eventId={event.id}
        />
      ) : (
        <p>Event has not started yet!</p>
      )}
    </div>
  )
}
